import { Component, Input, OnInit } from "@angular/core";
import { DateTime, Interval } from "luxon";
import { WidgetsService } from "src/app/shared/services/widgets.service";

@Component({
  selector: 'widget-accounts',
  templateUrl: './widget-accounts.component.html',
  styleUrls: ['./widget-accounts.component.scss']
})
export class WidgetAccountsComponent implements OnInit {
  @Input() widgetConfig;

  loading = false;
  failedToLoad: boolean = false;
  noData = false;
  accountsCreated: number = null;
  accountsAccepted: number = null;
  
  constructor(private widgetsService: WidgetsService) { }

  ngOnInit() {
    this.init()
  }

  async init() {
    this.loading = true;

    try {
      const res: any = await this.widgetsService.getAccountsWidgetData().toPromise();
      if (res.totalRegisteredUsers === null && res.totalRegisteredAndConfirmedTandCUsers === null) {
        this.noData = true;
      } else {
        this.accountsCreated = res.totalRegisteredUsers;
        this.accountsAccepted = res.totalRegisteredAndConfirmedTandCUsers;
      }
      this.loading = false;
      this.failedToLoad = false;
    } catch (error) {
      this.loading = false;
      this.failedToLoad = true;
      console.log(error);
    }
  }

  reloadWidget() {
    this.init();
  }
}
